import { getFrontendFlags, type IMutableContext } from '@unleash/nextjs';

/**
 * The fetchFeatureFlag service is used to fetch all flags from remote based on the config/context.
 *
 * @param context : Object that distinguishes flags.
 * @returns: Array of enabled flags.
 */
export const fetchFeatureFlags = async (context: IMutableContext) => {
  //To be fetched from cookie, once set, yet to be discussed.
  let togglesData = { toggles: [] } as any;
  try {
    togglesData = await getFrontendFlags({
      refreshInterval: 0,
      context,
      disableRefresh: true
    });
  } catch (error) {
    console.log('Something went wrong while fetching feature flags.', error);
  }

  return togglesData.toggles;
};
